<template>
  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">
    <f7-toolbar>
      <div class="left">
      </div>
      <div class="right">
        <f7-link sheet-close>
          Sluiten
        </f7-link>
      </div>
    </f7-toolbar>

    <activity-weight-calculator-card
      :activity="activity"
    ></activity-weight-calculator-card>

  </f7-sheet>
</template>

<script>

    import ActivityWeightCalculatorCard from "./ActivityWeightCalculatorCard.vue";

    export default {
        components: {
            ActivityWeightCalculatorCard,
        },

        props: [
            'show',
            'activity',
        ],

        mixins: [
            //
        ],

        data: function () {
            return {
                notes: '',
                updated: 0,
            };
        },

        computed: {
            //
        },

        created() {
            //
        },

        mounted() {
            //
        },

        methods: {
            //
        },

        watch: {
            //
        }
    };
</script>
